<!--
  A placeholder that occupies the exact space its content will. Loading a screen
  should not move anything once the data lands.
-->
<script lang="ts">
  import { sweepGate } from './sweep-gate';

  interface Props {
    width?: string;
    height?: string;
    ratio?: string | undefined;
    radius?: string;
    class?: string;
  }
  let { width = '100%', height = '1em', ratio = undefined, radius = 'var(--radius)', class: klass = '' }: Props =
    $props();
</script>

<div
  class="skeleton {klass}"
  style:width
  style:height={ratio ? 'auto' : height}
  style:aspect-ratio={ratio}
  style:border-radius={radius}
  aria-hidden="true"
  use:sweepGate
></div>

<style>
  .skeleton {
    position: relative;
    overflow: hidden;
    background: var(--surface-2);
    flex: none;
  }
  /* The sweep runs only while `lit` — on or near the glass (`sweep-gate.ts`).
     A cold Home holds ~250 of these below the fold, and every one of them
     used to paint this gradient every frame, for ever, unseen. Unlit, the
     pseudo-element sits at a fully transparent frame: indistinguishable. */
  .skeleton.lit::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(100deg, transparent 20%, rgb(255 255 255 / 0.045) 42%, transparent 64%);
    background-size: 240% 100%;
    animation: sweep 1.4s var(--ease) infinite;
  }
  @keyframes sweep {
    from {
      background-position: 140% 0;
    }
    to {
      background-position: -60% 0;
    }
  }
</style>
